import { render, staticRenderFns } from "./quota.vue?vue&type=template&id=29600a42&scoped=true&"
import script from "./quota.vue?vue&type=script&lang=js&"
export * from "./quota.vue?vue&type=script&lang=js&"
import style0 from "./quota.vue?vue&type=style&index=0&id=29600a42&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29600a42",
  null
  
)

export default component.exports